<template>
  <v-main style="height: 100vh; overflow-y: hidden">
    <div id="particles-js"></div>
    <v-navigation-drawer fixed right width="480" class="px-16 navigation-drawer-modern" color="transparent">
      <kinesis-container>
        <v-container>
          <kinesis-element :strength="15" type="depth">
            <v-row style="height: 80vh" align="center">
              <v-col cols="12">
                <v-form v-model="loginForm">
                  <v-card class="card" color="transparent">
                    <v-card-title class="d-block" align="center">
                      <img src="@/assets/img/policia.png" width="140" class="logo mb-8" />
                      <div class="font-weight-bold text-h6 justify-center white--text">Inicio de sesión</div>
                    </v-card-title>
                    <v-card-text>
                      <v-form v-model="loginForm">
                        <v-text-field
                          v-model="name"
                          outlined
                          dense
                          label="Usuario"
                          color="secondary"
                          class="input-modern"
                          prepend-inner-icon="mdi-account-outline"
                        ></v-text-field>
                        <v-text-field
                          v-model="password"
                          outlined
                          dense
                          label="Contraseña"
                          type="password"
                          color="secondary"
                          class="input-modern"
                          prepend-inner-icon="mdi-lock-outline"
                          :rules="passwordRules"
                        ></v-text-field>
                      </v-form>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                      <v-container>
                        <v-row>
                          <v-col cols="8" offset-md="2" align="center">
                            <v-btn
                              color="secondary"
                              class="mb-4 btn-login-modern"
                              v-on:click="triggerLogin()"
                              block
                              large
                              :disabled="!loginForm || loading"
                              :loading="loading"
                            >
                              <v-icon left>mdi-login</v-icon>
                              Iniciar sesión
                            </v-btn>
                            <a href="#" class="text-decoration-none forgot-password-link text-subtitle-2"
                              >¿Ha olvidado su contraseña?</a
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-col>
            </v-row>
          </kinesis-element>
        </v-container>
      </kinesis-container>
      <template v-slot:append>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-btn text to="/" class="btn-back-modern">
                <v-icon small left>mdi-arrow-left</v-icon>
                Volver al portal
              </v-btn>
            </v-col>
            <v-col cols="12" align="center">
              <kinesis-container>
                <kinesis-element :strength="15" type="depth">
                  <v-img src="@/assets/img/eon.png" max-width="240" class="eon-logo"></v-img>
                </kinesis-element>
              </kinesis-container>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-navigation-drawer>
    <div class="white--text armeria font-weight-black">ESTADO DE FUERZA</div>
    <login-perfil-dialog-component :active="activeModal" @close="activeModal = false"></login-perfil-dialog-component>
  </v-main>
</template>
<style scoped>
/* ===========================
   FONDO CON PARTICLES MODERNO
   =========================== */
#particles-js {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  overflow: hidden;
}

/* Overlay con radial gradients para puntos de luz */
#particles-js::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 20% 30%, rgba(187, 134, 252, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(3, 218, 198, 0.1) 0%, transparent 50%);
  animation: moveGradient 20s ease-in-out infinite;
  pointer-events: none;
}

@keyframes moveGradient {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-10%, -10%);
  }
}

/* ===========================
   NAVIGATION DRAWER MODERNO
   =========================== */
::v-deep .v-navigation-drawer.navigation-drawer-modern {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-left: 1px solid rgba(187, 134, 252, 0.2);
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.5);
}

/* Animación de entrada del drawer */
::v-deep .v-navigation-drawer--is-mobile {
  animation: slideInRight 0.5s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* ===========================
   CARD DE LOGIN CON GLASS-MORPHISM
   =========================== */
.card {
  background: rgba(30, 30, 46, 0.8) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(187, 134, 252, 0.3) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
  animation: fadeInUp 0.8s ease-out;
}

.card:hover {
  transform: translateY(-4px);
  border-color: rgba(187, 134, 252, 0.5);
  box-shadow: 0 12px 48px rgba(187, 134, 252, 0.4) !important;
}

/* Título del card */
::v-deep .v-card-title {
  background: rgba(187, 134, 252, 0.08);
  border-bottom: 1px solid rgba(187, 134, 252, 0.2);
  padding: 24px !important;
}

::v-deep .v-card-title .text-h6 {
  color: #ffffff !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  font-size: 1.25rem !important;
}

/* Card text */
::v-deep .v-card-text {
  padding: 32px 24px !important;
}

/* Card actions */
::v-deep .v-card-actions {
  padding: 24px !important;
  background: rgba(187, 134, 252, 0.05);
  border-top: 1px solid rgba(187, 134, 252, 0.1);
}

/* ===========================
   LOGO DE POLICÍA
   =========================== */
img.logo {
  filter: drop-shadow(0 4px 12px rgba(187, 134, 252, 0.4));
  transition: all 0.3s ease;
}

img.logo:hover {
  filter: drop-shadow(0 8px 24px rgba(187, 134, 252, 0.6));
  transform: scale(1.05);
}

/* ===========================
   INPUTS MODERNOS
   =========================== */
::v-deep .v-text-field.input-modern {
  border-radius: 12px;
  margin-bottom: 16px;
}

::v-deep .v-text-field.input-modern .v-input__slot {
  background: rgba(0, 0, 60, 0.6) !important;
  border: 1px solid rgba(187, 134, 252, 0.3) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  min-height: 48px !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* Hover state */
::v-deep .v-text-field.input-modern .v-input__slot:hover {
  border-color: rgba(187, 134, 252, 0.5) !important;
  background: rgba(0, 0, 60, 0.8) !important;
}

/* Focus state - efecto glow */
::v-deep .v-text-field.input-modern.v-input--is-focused .v-input__slot {
  border-color: #bb86fc !important;
  box-shadow: 0 0 0 3px rgba(187, 134, 252, 0.2) !important;
  background: rgba(0, 0, 60, 0.9) !important;
}

/* Label */
::v-deep .v-text-field.input-modern .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  font-size: 0.9375rem;
}

::v-deep .v-text-field.input-modern.v-input--is-focused .v-label,
::v-deep .v-text-field.input-modern .v-label--active {
  color: #bb86fc !important;
  font-weight: 600;
}

/* Texto dentro del input */
::v-deep .v-text-field.input-modern input {
  color: #ffffff !important;
  font-size: 0.9375rem;
}

/* Placeholder */
::v-deep .v-text-field.input-modern input::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}

/* Íconos prepend-inner */
::v-deep .v-text-field.input-modern .v-input__prepend-inner .v-icon {
  color: rgba(187, 134, 252, 0.7) !important;
  transition: color 0.3s ease;
}

::v-deep .v-text-field.input-modern.v-input--is-focused .v-input__prepend-inner .v-icon {
  color: #bb86fc !important;
}

/* Mensaje de error */
::v-deep .v-text-field.input-modern .v-messages__message {
  color: #ff5252 !important;
  font-size: 0.75rem;
  margin-top: 4px;
}

/* Fieldset (border outline) */
::v-deep .v-text-field.input-modern fieldset {
  border: none !important;
}

/* ===========================
   BOTÓN DE LOGIN MODERNO
   =========================== */
::v-deep .v-btn.btn-login-modern {
  background: linear-gradient(135deg, #bb86fc 0%, #03dac6 100%) !important;
  color: #000000 !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
  letter-spacing: 0.5px;
  border-radius: 12px !important;
  text-transform: none !important;
  height: 48px !important;
  box-shadow: 0 4px 16px rgba(187, 134, 252, 0.4) !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn.btn-login-modern:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(187, 134, 252, 0.6) !important;
}

::v-deep .v-btn.btn-login-modern:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(187, 134, 252, 0.5) !important;
}

/* Efecto ripple/onda al hacer click */
::v-deep .v-btn.btn-login-modern::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn.btn-login-modern:active::before {
  width: 300px;
  height: 300px;
}

/* Botón deshabilitado */
::v-deep .v-btn.btn-login-modern:disabled {
  opacity: 0.4 !important;
  transform: none !important;
  box-shadow: none !important;
  background: rgba(187, 134, 252, 0.2) !important;
}

/* Loading state */
::v-deep .v-btn.btn-login-modern .v-btn__loading {
  color: #000000 !important;
}

/* Ícono del botón */
::v-deep .v-btn.btn-login-modern .v-icon {
  color: #000000 !important;
}

/* ===========================
   LINK CONTRASEÑA OLVIDADA
   =========================== */
.forgot-password-link {
  color: #bb86fc !important;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
}

.forgot-password-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -2px;
  left: 50%;
  background: #bb86fc;
  transition: all 0.3s ease;
  transform: translateX(-50%);
  box-shadow: 0 0 8px rgba(187, 134, 252, 0.6);
}

.forgot-password-link:hover {
  color: #03dac6 !important;
  text-shadow: 0 0 12px rgba(187, 134, 252, 0.6);
}

.forgot-password-link:hover::after {
  width: 100%;
  background: #03dac6;
}

/* ===========================
   BOTÓN VOLVER
   =========================== */
::v-deep .v-btn.btn-back-modern {
  color: #bb86fc !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px;
  background: rgba(187, 134, 252, 0.1) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-btn.btn-back-modern:hover {
  background: rgba(187, 134, 252, 0.2) !important;
  transform: translateX(-4px);
}

::v-deep .v-btn.btn-back-modern .v-icon {
  color: #bb86fc !important;
  transition: transform 0.3s ease;
}

::v-deep .v-btn.btn-back-modern:hover .v-icon {
  transform: translateX(-2px);
}

/* ===========================
   LOGO EON
   =========================== */
.v-img.eon-logo {
  filter: drop-shadow(0 4px 12px rgba(187, 134, 252, 0.3));
  transition: all 0.3s ease;
  border-radius: 8px;
}

.v-img.eon-logo:hover {
  filter: drop-shadow(0 8px 24px rgba(187, 134, 252, 0.5));
  transform: scale(1.02);
}

/* ===========================
   TEXTO "ESTADO DE FUERZA"
   =========================== */
.armeria {
  position: fixed;
  bottom: 0;
  left: 48px;
  font-size: 96px;
  font-weight: 900;
  opacity: 0.15;
  color: #ffffff;
  text-shadow: 0 4px 16px rgba(187, 134, 252, 0.5);
  letter-spacing: -2px;
  background: linear-gradient(135deg, #bb86fc 0%, #03dac6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: pulseText 4s ease-in-out infinite;
}

@keyframes pulseText {
  0%,
  100% {
    opacity: 0.15;
    text-shadow: 0 4px 16px rgba(187, 134, 252, 0.3);
  }
  50% {
    opacity: 0.25;
    text-shadow: 0 8px 32px rgba(187, 134, 252, 0.5);
  }
}

/* ===========================
   SCROLLBAR PERSONALIZADA
   =========================== */
::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  width: 8px;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: rgba(187, 134, 252, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
  background: rgba(187, 134, 252, 0.6);
}

/* ===========================
   ANIMACIÓN DE ENTRADA
   =========================== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===========================
   RESPONSIVE DESIGN
   =========================== */
@media (max-width: 960px) {
  /* Reducir ancho del drawer */
  ::v-deep .v-navigation-drawer {
    width: 360px !important;
  }

  /* Ajustar padding */
  ::v-deep .v-navigation-drawer.navigation-drawer-modern {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  /* Logo más pequeño */
  img.logo {
    width: 100px !important;
  }

  /* Botón más compacto */
  ::v-deep .v-btn.btn-login-modern {
    height: 44px !important;
    font-size: 0.9375rem !important;
  }

  /* Ocultar texto de marca en tablet */
  .armeria {
    font-size: 72px;
    opacity: 0.1;
  }
}

@media (max-width: 600px) {
  /* Drawer a pantalla completa */
  ::v-deep .v-navigation-drawer {
    width: 100% !important;
  }

  /* Título de la card más pequeño */
  ::v-deep .v-card-title .text-h6 {
    font-size: 1.125rem !important;
  }

  /* Logo EON más pequeño */
  .v-img.eon-logo {
    max-width: 180px !important;
  }

  /* Ocultar texto de marca en móvil */
  .armeria {
    display: none;
  }
}

/* Scroll suave */
html {
  scroll-behavior: smooth;
}
</style>
<script>
import 'particles.js'
import { textAnimation } from '../plugins/anime'
import sha1 from 'sha1'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import LoginPerfilDialogComponent from '../components/LoginPerfilDialogComponent.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    LoginPerfilDialogComponent,
  },

  mounted() {
    this.initParticles()
    textAnimation()
  },

  data() {
    return {
      PERFILES,
      loginForm: false,
      loading: false,
      name: '',
      password: '',
      emailRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => /.+@.+\..+/.test(v) || 'Ingrese un correo electrónico válido.',
      ],
      passwordRules: [(v) => !!v || 'Este campo es requerido.'],

      activeModal: false,
    }
  },

  computed: {
    ...mapGetters({
      token: 'getToken',
      perfil: 'getPerfil',
      idPersonal: 'getIdPersonal',
    }),
  },

  watch: {
    token(newToken) {
      if (newToken.length > 0) {
        if (this.perfil !== '') {
          switch (this.perfil) {
            case this.PERFILES.Armeria:
              window.location.replace('armeria/inventario_armas')
              break
            case this.PERFILES.Equipamiento:
              window.location.replace('equipamiento/personal')
              break
            case this.PERFILES.Profesionalización:
              window.location.replace('profesionalizacion/dashboard')
              break
            case this.PERFILES['Personal / Site']:
              window.location.replace('personal/dashboard')
              break
            case this.PERFILES['Recursos Humanos']:
              window.location.replace('recursos_humanos/dashboard')
              break
            case this.PERFILES['Enlace C3']:
              window.location.replace('enlace_c3/dashboard')
              break
            case this.PERFILES['Administrador IPH+']:
              window.location.replace('launcher')
              break
            case this.PERFILES['Asuntos Internos']:
              window.location.replace('asuntos_internos/personal')
              break
            case this.PERFILES['Consejo de Honor y Justicia']:
              window.location.replace('asuntos_internos/personal')
              break
            case this.PERFILES.Policia:
              window.location.replace('policia/' + this.idPersonal)
              break

            // * Nuevos perfiles
            case this.PERFILES.IFCSP_PROFESIONALIZACION:
              window.location.replace('profesionalizacion/dashboard')
              break
            case this.PERFILES.IFCSP_RECLUTAMIENTO:
              window.location.replace('profesionalizacion/dashboard')
              break
            case this.PERFILES.IFCSP_ADMINISTRADOR:
              window.location.replace('profesionalizacion/dashboard')
              break
            case this.PERFILES.REP_ADMINISTRADOR:
              window.location.replace('personal/dashboard')
              break
            case this.PERFILES.REP_REGISTRO:
              window.location.replace('personal/dashboard')
              break
            case this.PERFILES.REP_CREDENCIALIZACION:
              window.location.replace('personal/dashboard')
              break
            case this.PERFILES.REP_BIOMETRIA:
              window.location.replace('personal/dashboard')
              break
            case this.PERFILES['ENLACE C3_CAPTURA DE RESULTADOS']:
              window.location.replace('enlace_c3/dashboard')
              break
            case this.PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE']:
              window.location.replace('enlace_c3/dashboard')
              break
            case this.PERFILES['ENLACE C3_ADMINISTRADOR']:
              window.location.replace('enlace_c3/dashboard')
              break
            case this.PERFILES.RH_ADMINISTRADOR:
              window.location.replace('recursos_humanos/dashboard')
              break
            case this.PERFILES['RH_TRAMITES ADMINISTRATIVOS']:
              window.location.replace('recursos_humanos/dashboard')
              break
            case this.PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION']:
              window.location.replace('recursos_humanos/dashboard')
              break
            case this.PERFILES['RH_REGISTRO DE PERSONAL']:
              window.location.replace('recursos_humanos/dashboard')
              break
            case this.PERFILES['ARMERIA_PASE DE LISTA']:
              window.location.replace('armeria/inventario_armas')
              break
            case this.PERFILES.ARMERIA_LOC:
              window.location.replace('armeria/inventario_armas')
              break
            case this.PERFILES['ARMERIA_PERSONAL LOC']:
              window.location.replace('armeria/inventario_armas')
              break
            case this.PERFILES['ARMERIA_CATALOGOS E INVENTARIO ARMAS']:
              window.location.replace('armeria/inventario_armas')
              break
            case this.PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS']:
              window.location.replace('armeria/inventario_armas')
              break
            case this.PERFILES.EQUIPAMIENTO_ADMINISTRADOR:
              window.location.replace('equipamiento/personal')
              break
            case this.PERFILES.DP_ADMINISTRADOR:
              window.location.replace('desarrollo_profesional/personal')
              break
            case this.PERFILES.DP_CUP:
              window.location.replace('desarrollo_profesional/personal')
              break
            case this.PERFILES.DP_CONVOCATORIAS_CONDECORACIONES:
              window.location.replace('desarrollo_profesional/personal')
              break
            case this.PERFILES.DP_EVALUACIONES:
              window.location.replace('desarrollo_profesional/personal')
              break
            default:
              console.log(this.perfil)
              this.activeModal = true
              break
          }
        } else {
          this.activeModal = true
        }
      }
    },
  },

  methods: {
    ...mapActions(['login']),

    ...mapMutations(['SET_SNACKBAR_MESSAGE', 'SET_AUTH', 'DISABLE_LOADER', 'ENABLE_LOADER']),
    ...mapActions('personal', ['fetchPersonal']),

    ...mapActions('capacitador', ['fetchCapacitadores']),
    ...mapActions('aula', ['fetchAulas']),
    ...mapActions('curso', ['fetchCursos']),
    ...mapActions('cursoProgramado', ['fetchCursosProgramados']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignados']),
    ...mapActions('categoriaCurso', ['fetchCategoriasCursos']),
    ...mapActions('estatusCurso', ['fetchEstatusCurso']),
    ...mapActions('estatusCursoPersonal', ['fetchEstatusCursoPersonal']),
    ...mapActions('estatusAula', ['fetchClassroomStatus']),
    ...mapActions('tipoCurso', ['fetchCourseTypes']),

    ...mapActions('estatusEstudios', ['fetchEstatusEstudios']),
    ...mapActions('calibre', ['fetchCalibres']),
    ...mapActions('tipoArma', ['fetchTiposArma']),
    ...mapActions('marcaArma', ['fetchMarcaArma']),
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapActions('estatusArma', ['fetchEstatusArma']),
    ...mapActions('arma', ['fetchArmas']),
    ...mapActions('tipoAsignacionArma', ['fetchTipoAsignacion']),
    ...mapActions('tipoEntregaArma', ['fetchTiposEntrega']),
    ...mapActions('licenciaOficialColectiva', ['fetchLocs']),

    ...mapActions('personal', ['fetchPersonal']),

    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('principio', ['fetchPrincipios']),
    ...mapActions('reactivo', ['fetchReactivos']),
    ...mapActions('frecuenciaRespetoPrincipio', ['fetchFrecuenciaRespetoPrincipio']),
    ...mapActions('periodicidad', ['fetchPeriodicidad']),
    ...mapActions('resultado', ['fetchResultados']),
    ...mapActions('productividad', ['fetchProductividad']),
    ...mapActions('funcion', ['fetchFunciones']),
    ...mapActions('indicador', ['fetchIndicadores']),
    ...mapActions('frecuenciaProductividad', ['fetchFrecuenciaProductividad']),
    ...mapActions('actoRelevante', ['fetchActosRelevantes']),

    ...mapActions('tipoItem', ['fetchTiposItem']),

    ...mapActions('item', ['fetchItemsByType']),

    ...mapActions('preaspirante', ['fetchPreaspirantes']),

    ...mapActions('candidato', ['fetchCandidatos']),
    ...mapActions('categoria', ['fetchCategorias']),

    ...mapActions('sede', ['fetchSedes']),
    ...mapActions('subsede', ['fetchSubsedes']),
    ...mapActions('puesto', ['fetchPuestos']),
    ...mapActions('dependencia', ['fetchDependencias']),

    ...mapActions('estudio', ['fetchTipoEstudios']),

    ...mapActions('perfil', ['fetchPerfiles']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapActions('estado', ['fetchEstados']),
    ...mapActions('sexo', ['fetchSexo']),

    ...mapActions('estatusPersonal', ['fetchEstatusPersonal']),
    ...mapActions('tipoDocumento', ['fetchTipoDocumento']),

    ...mapActions('preaspirante', ['fetchAspirantes']),

    ...mapActions('rama', ['fetchRamas']),
    ...mapActions('region', ['fetchRegiones']),
    ...mapMutations(['ENABLE_LOADER', 'DISABLE_LOADER']),

    initParticles() {
      window.particlesJS('particles-js', {
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: '#ffffff',
          },
          shape: {
            type: 'circle',
            stroke: {
              width: 0,
              color: '#000000',
            },
            polygon: {
              nb_sides: 5,
            },
            image: {
              src: 'img/github.svg',
              width: 100,
              height: 100,
            },
          },
          opacity: {
            value: 0.4,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 3,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: '#ffffff',
            opacity: 0.3,
            width: 1,
          },
          move: {
            enable: true,
            speed: 6,
            direction: 'none',
            random: false,
            straight: false,
            out_mode: 'out',
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: 'canvas',
          events: {
            onhover: {
              enable: true,
              mode: 'repulse',
            },
            onclick: {
              enable: true,
              mode: 'push',
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 400,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
      })
    },

    triggerLogin: async function () {
      this.loading = true
      await this.login({
        loginField: this.name,
        passwordField: sha1(this.password).toUpperCase(),
      })

      this.loading = false
    },
  },
}
</script>
